module.exports = __webpack_public_path__ + "static/media/shield.3a313818.svg";